import Highcharts from 'highcharts';
import { useCallback } from 'react';

interface SVGRendererWithExportSupport extends Highcharts.SVGRenderer {
  forExport: boolean | undefined;
}

export const useSkipExportRenderingCallback = (
  callback: Highcharts.ChartCallbackFunction,
): Highcharts.ChartCallbackFunction => {
  return useCallback<Highcharts.ChartCallbackFunction>(
    (chart) => {
      if ((chart.renderer as SVGRendererWithExportSupport).forExport === true) {
        return;
      }
      callback(chart);
    },
    [callback],
  );
};
